import ColorSelection from '../components/ColorSelection';
import ConvertHeight from '../components/ConvertHeight';

export default class CategoryModels {
  constructor(el) {
    this.$el = $(el);
    this.class = {
      hidden: 'hidden',
    };

    this.dom = {
      $models: this.$el.find('.js-model-item'),
      $jsModelColorsWrap: this.$el.find('.js-model-colors-wrap'),
    };

    this.elementClasses = {
      modelItemSelector: '.js-model-item',
    };
    this.init();
  }

  init() {
    this.changeColorModelEvent();
    this.convertHeight();
  }

  changeColorModelEvent() {
    this.dom.$jsModelColorsWrap.each((_i, el) => {
      const colorSelection = new ColorSelection(el);
      const $model = $(el).closest(this.elementClasses.modelItemSelector);
      const $radios = $model.find('.js-color-radio');
      const $modelThumb = $model.find('.js-model-thumb');
      colorSelection.changeColorEvent(($radio) => {
        const idx = $radios.index($radio);
        $modelThumb.addClass(this.class.hidden);
        $modelThumb.eq(idx).removeClass(this.class.hidden);
      });
    });
  }

  updateShowHideThumbnail($wrap, idx) {
    const $modelThumb = $wrap.find('.js-model-thumb');
    $modelThumb.addClass(this.class.hidden);
    $modelThumb.eq(idx).removeClass(this.class.hidden);
  }

  convertHeight() {
    const convertHeight = new ConvertHeight(this.dom.$models);
    convertHeight.initialize();
  }
}
